export function getImageUrlFromId(assetId) {
  return `${process.env.REACT_APP_IMAGES_URL}/${assetId}`;
}

export function getAssetUrlFromId(assetId) {
  return `${process.env.REACT_APP_ASSETS_URL}/${assetId}`;
}
